export const InternationalIcon = () => (
	<svg width="41" height="41" viewBox="0 0 41 41" fill="none" xmlns="http://www.w3.org/2000/svg">
		<rect x="1" y="1" width="40" height="40" rx="5.64706" fill="#252252" />
		<mask
			id="path-2-outside-1_19083_51081"
			maskUnits="userSpaceOnUse"
			x="10.1293"
			y="14.2945"
			width="28.2843"
			height="28.2843"
			fill="black"
		>
			<rect fill="white" x="10.1293" y="14.2945" width="28.2843" height="28.2843" />
			<path d="M13.999 31.7953C15.7597 33.5561 18.1612 34.5318 20.6752 34.5078C23.1892 34.4839 25.6098 33.4622 27.4044 31.6677C29.199 29.8731 30.2206 27.4525 30.2446 24.9385C30.2685 22.4245 29.2928 20.023 27.532 18.2623L20.7655 25.0288L13.999 31.7953Z" />
		</mask>
		<path
			d="M13.999 31.7953C15.7597 33.5561 18.1612 34.5318 20.6752 34.5078C23.1892 34.4839 25.6098 33.4622 27.4044 31.6677C29.199 29.8731 30.2206 27.4525 30.2446 24.9385C30.2685 22.4245 29.2928 20.023 27.532 18.2623L20.7655 25.0288L13.999 31.7953Z"
			fill="white"
		/>
		<path
			d="M13.999 31.7953C15.7597 33.5561 18.1612 34.5318 20.6752 34.5078C23.1892 34.4839 25.6098 33.4622 27.4044 31.6677C29.199 29.8731 30.2206 27.4525 30.2446 24.9385C30.2685 22.4245 29.2928 20.023 27.532 18.2623L20.7655 25.0288L13.999 31.7953Z"
			stroke="white"
			strokeWidth="5"
			mask="url(#path-2-outside-1_19083_51081)"
		/>
		<path d="M9.96286 26.0144L28.1191 7.85801L16.1772 6.8227" stroke="white" strokeWidth="2.5" />
	</svg>
);
